const semanticClassNames = {
  root: 'video-box',
} as const;

export default semanticClassNames;
